<div [formGroup]="formGroup" class="control control--input control--switch-group" [hidden]="hidden">
  <div class="control__header__box">
    <div *ngIf="hasLabel" class="control__header">
      <label class="control__header__label" [for]="model.key" [title]="model.label">
        {{ label }}
      </label>
      <div class="control__header__sublabel" *ngIf="model.subLabel">{{ model.subLabel }}</div>
      <div class="control__header__error" *ngIf="hasError" [title]="error">{{ error }}</div>
    </div>
  </div>

  <div [formGroupName]="model.key">
    <div class="switch-list" *ngIf="hasOptions; else noData">
  <div class="switch-row" *ngFor="let item of options; trackBy: trackByValue">
    <div class="switch-label">
      {{ item.text }}
      <a *ngIf="item.url" href="{{ item.url }}" target="_blank" rel="noopener noreferrer">
        <i class="fa fa-link link-icon"></i>
      </a>
    </div>
    <p-inputSwitch
      [inputId]="item.key"
      [formControlName]="item.key"
      [styleClass]="classes"
      (onChange)="onChange.emit($event); onInput.emit($event);">
    </p-inputSwitch>
  </div>
</div>
  </div>

  <ng-template #noData>
    <div class="text--danger">Information Not Available.</div>
  </ng-template>
</div>